<template>
  <v-container fluid>
    <!-- <v-breadcrumbs :items="items">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs> -->
    <div id="app ">
      <div style="display: flex; justify-content: space-between;">
        <!-- <v-col cols="11"> -->
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-row class="mt-0 border-bottom">
      <v-col>
        <!-- <DateRange></DateRange> -->
        <newFiltercomp :filter_data="param" />
      </v-col>
    </v-row>

    <div v-if="oeeData" class="d-flex align-content-space-around flex-wrap">
      <div v-bind:key="apq.id" v-for="apq in oeeData" class="mb-3 mt-5">
        <v-col>
          <router-link
            :to="{
              name: 'apqMachine',
              params: {
                macId: apq.machine_id,
                start_date: start_date,
                end_date: end_date,
                route_path: 'apqMachine',
              },
            }"
            style="text-decoration: none"
          >
            <SingleMachine
              class="main"
              v-bind:apq="apq"
              style="padding-top: 20px"
            />
          </router-link>
        </v-col>
      </div>
      <h1
        v-if="oeeData.length == 0 && !showLoader"
        style="margin-top:10px;"
      ></h1>
    </div>
  </v-container>
</template>

<script>
import SingleMachine from "../components/newSingleOEE";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import newFiltercomp from "../components/newFiltercomp.vue";
import axios from "axios";
import router from "../router";

export default {
  components: {
    SingleMachine,
    newFiltercomp,
    Breadcrumb,
    LoaderProgress,
  },

  data: () => ({
    param: {
      machine: false,
      time_period: true,
      check: false,
      aggfunc: false,
      date: new Date().toISOString().slice(0, 10),
      date_2: new Date().toISOString().slice(0, 10),
      redirectStartDate: null,
      redirectEndDate: null,
      redirectPath: null,
      machine_id: null,
      drilldown_id: null,
    },
    //redirect variable sendng as param
    start_date: null,
    end_date: null,
    //redirect variable sendng as param
    filter_data: [],

    oeeData: [],
    showLoader: false,
    fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu1: false,
    menu2: false,
    selectedDate: "Today",
    dates: [],
    items1: ["Today", "Last Day", "Last 7 Days", "Last 15 Days", "Last Month"],
    items: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Plant Monitoring Dashboard",
        disabled: false,
        href: "/plantMonitoringDashboard",
      },
      {
        text: "OEE Monitoring Dashboard",
        disabled: true,
      },
    ],
    // StarTime :'',
    // EndTime :''
  }),
  beforeDestroy() {
    console.log(
      "beforedestroy this.start_date,this.end_date",
      this.start_date,
      this.end_date
    );
  },

  created() {
    console.log(
      "this.$router",
      this.$router.app._route.params.end_date,
      this.$router.app._route.params.start_date,
      this.$router.app._route.params.route_path
    );
    this.param.redirectStartDate = this.$router.app._route.params.start_date;
    this.param.redirectEndDate = this.$router.app._route.params.end_date;
    this.param.redirectPath = this.$router.app._route.params.route_path;
    this.param.machine_id = this.$router.app._route.params.machine_id;
    console.log("checking params values", this.param);
  },
  // mounted(){
  //   console.log("this.$router",this.$router.app._route.params.end_date,this.$router.app._route.params.start_date,this.$router.app._route.params.route_path)
  //   this.param.redirectStartDate = this.$router.app._route.params.start_date
  //   this.param.redirectEndDate = this.$router.app._route.params.end_date
  //   this.param.redirectPath = this.$router.app._route.params.route_path
  //   console.log("checking params values",this.param)
  // },

  // computed: {
  //   dateRangeText() {
  //     return this.dates.join(" ~ ");
  //   },
  // },
  methods: {
    datePicked(x) {
      console.log(">>>> [datePicked] in OEE", x);
      const start = parseInt(x[0]);
      const end = parseInt(x[1]);
      console.log(
        "human readable format: ",
        new Date(start * 1000),
        new Date(end * 1000)
      );
      this.getOEE(x[0], x[1]);
    },
    addSelectedMachineToSession(machineId) {
      sessionStorage.setItem("machineID", machineId);
    },

    intervalFetchData(machine, startDate, endDate, withoutDate) {
      // if (sessionStorage.start_date!==null || sessionStorage.start_date!=='' &&  sessionStorage.end_date!==null || sessionStorage.end_date!==''){
      //   console.log("checking session if true")
      //   startDate = sessionStorage.start_date
      //   endDate = sessionStorage.end_date
      // }
      console.log(
        ">>>> [getOEE] in OEE",
        machine,
        startDate,
        endDate,
        withoutDate
      );

      let todaysDate = new Date();
      let dateString = `${todaysDate.getFullYear()}-${todaysDate.getMonth() +
        1}-${todaysDate.getDate()}`;
      let start = startDate
        ? startDate
        : (new Date(dateString).getTime() / 1000).toFixed();
      let end = endDate ? endDate : (new Date().getTime() / 1000).toFixed();
      // let customer_id = this.$route.params.macId || -1;
      let params = "";
      console.log("checking datestring ", dateString);

      // if (customer_id != -1) {
      //   console.log("if statement executed", sessionStorage);
      //   params = withoutDate
      //     ? ""
      //     : `?startdate=${start}&enddate=${end}&customer_id=${customer_id}&machine_id=${this.param.machine_id}`;
      // } else {
      // console.log("else statement executed this.redirectDate",this.redirect_date)'

      params = withoutDate
        ? ""
        : `?startdate=${start}&enddate=${end}&machine_id=${this.param.machine_id}`;
      // }
      this.showLoader = true;
      //redirect chnages

      this.start_date = start;
      this.end_date = end;

      //redirect chnages
      console.log(
        "checking param in multipleOEE",
        this.start_date,
        this.end_date,
        this.param.machine_id
      );
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getOEEParameters${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.showLoader = false;
          let data = response.data.data || [];
          let dataKeys = [];
          if (data.length > 0) {
            Object.entries(data).forEach(([key, value]) => {
              console.log(key, value);
              dataKeys.push(key);
            });
            console.log("keys lsit to evalutaiton", dataKeys);
            let structuredAPQ = data.map((e) => {
              let id = e.machine_name;
              let availability = e.availability * 100;
              availability = availability.toFixed(0);
              let performance = e.performance * 100;
              performance = performance.toFixed(0);
              let quality = e.quality * 100;
              quality = quality.toFixed(0);
              let oee =
                (availability * performance * quality) / (100 * 100) || 0;
              oee = oee.toFixed(0);
              let machine_id = e.machine_id;
              let singleMachineOEE = {
                id,
                availability,
                performance,
                quality,
                oee,
                machine_id,
              };
              return singleMachineOEE;
            });

            this.oeeData = structuredAPQ;
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    onSelectCustomDate(val) {
      this.selectedDate = val;
    },
    onSelectFromToDate() {
      this.selectedDate = this.fromDate + " ~ " + this.toDate;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .main {
    margin-left: -10px;
    width: 340px;
  }
}
.v-list-item--link {
  border-bottom: 1px solid #e1e1e1;
}

.row.bg-white.mydrop {
  padding: 13px;
}
.my-datelist.v-list {
  border-top: 1px solid #e1e1e1 !important;
}

.my-datelist .v-list-item__title {
  align-self: center;
  font-size: 1.1rem;
  color: #7e84a3;
}

.my-datelist .v-list-item:hover {
  background-color: #e9e9e9;
}

.my-datelist .v-list-item:hover .v-list-item__title {
  color: #0c479d;
}

.my-datelist.v-sheet.v-list {
  padding: 0;
  margin-top: -35px;
}

.btn-square2 {
  height: 48px !important;
  min-width: 48px !important;
  padding: 0 !important;
  border-radius: 5px !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
